import React from "react"
import { useTranslation } from "react-i18next"
import { styled, Theme } from "@mui/material/styles"
import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"
import { getFormattedDate } from "utils/dateUtils"
import { useAppSelector } from "appRedux/hooks"
import CakeIcon from "components/atoms/_icons/CakeIcon"

type BioSectionProps = {
  show: boolean;
  handle: string;
  name?: string;
  birthday?: string;
  avatarTransitionDuration: number;
}

const formatDateOptions = { year: undefined, month: "long", day: "numeric" } as const

export default function BioSection(props: BioSectionProps) {
  const { show, handle, name, birthday, avatarTransitionDuration } = props

  const showEnlargedAvatar = useAppSelector((state) => state.global.showEnlargedAvatar)

  const { t } = useTranslation()

  return (
    show ? <BioWrapper
      avatarisenlarged={showEnlargedAvatar ? 1 : 0}
      transitionduration={avatarTransitionDuration}
    >
      <Username>{handle}@</Username>
      {name && <Name>{name}</Name>}
      <BirthdayContainer dark={birthday ? 1 : 0}>
        <CakeIcon/>
        <p>
          {birthday ? getFormattedDate(birthday, formatDateOptions) : <>{t("user.birthday")}</>}
        </p>
      </BirthdayContainer>
    </BioWrapper> : null
  )
}

type BioWrapperProps = {
  theme?: Theme;
  avatarisenlarged: 1 | 0;
  transitionduration: number
}

export const BioWrapper = styled(Stack)(({ theme, avatarisenlarged, transitionduration }: BioWrapperProps) => ({
  justifyContent: "center",
  alignItems: "center",
  transform: "translateY(-20px)",
  zIndex: avatarisenlarged ? 0 : 1,
  transition: "all 0.01s",
  transitionDelay: `${transitionduration - 0.02}s`
}))

type BirthdayContainerProps = {
  theme?: Theme;
  dark: 0 | 1;
}

export const BirthdayContainer = styled(Stack)(({ theme, dark }: BirthdayContainerProps) => ({
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  gap: 6,
  color: dark ? theme?.palette?.gray["12"] : theme?.palette?.gray["10"],
  fontSize: "1.1rem",

  "& svg": {
    stroke: dark ? theme?.palette?.gray["12"] : `${theme?.palette?.gray["10"]} !important`
  }
}))

export const Name = styled(Typography)(({ theme }) => ({
  height: "24px",
  fontSize: "1.1rem",
  color: theme.palette.gray["16"],
  textAlign: "center",
  lineHeight: 2
}))

export const Username = styled(Typography)(({ theme }) => ({
  width: "fit-content",
  fontSize: "1.4rem",
  fontWeight: 500,
  color: theme.palette.gray["16"],
  textAlign: "center",
  backgroundColor: theme.palette.primary["2"],
  borderRadius: "8px",
  padding: "2px 12px",
  marginBottom: "4px"
}))
